import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from '@/components/shadcn/form'
import { Input } from '@/components/shadcn/input'
import { BaseFieldProps, StatusIndicatorConfig } from './types'
import { computeStatusColorForValue, statusColorMap } from './statusIndicatorUtils'
import clsx from 'clsx'
import { useMemo } from 'react'
import { DocumentationButton } from './DocumentationButton'

export const StringField: React.FC<BaseFieldProps> = ({ field, formFieldName, control, variant }) => {
  return (
    <FormField
      control={control}
      name={formFieldName}
      render={({ field: formField }) => <StringFieldInner field={field} formField={formField} variant={variant} />}
    />
  )
}

const StringFieldInner: React.FC<{
  field: BaseFieldProps['field']
  formField: { value: unknown; onChange: (v: unknown) => void }
  variant: BaseFieldProps['variant']
}> = ({ field, formField, variant }) => {
  const isCompact = variant === 'row' || variant === 'inline'
  const { value: formFieldValue } = formField
  const { statusIndicator } = field
  const statusColor = useMemo(
    () =>
      computeStatusColorForValue(
        formFieldValue as string,
        statusIndicator as StatusIndicatorConfig | undefined,
        undefined
      ),
    [formFieldValue, statusIndicator]
  )
  return (
    <FormItem
      className={clsx('flex flex-1 flex-col', field.widget === 'hidden' && 'hidden', {
        'space-y-0': isCompact,
      })}
    >
      <div className={clsx('flex justify-start gap-2', { hidden: isCompact })}>
        <FormLabel>{field.title}</FormLabel>
        <DocumentationButton documentation={field.documentation} />
      </div>
      <FormDescription className={clsx('text-xs', { hidden: isCompact })}>{field.description}</FormDescription>
      <FormControl>
        <Input
          {...formField}
          disabled={field.readOnly}
          value={formField.value as string}
          className={clsx(statusColor ? statusColorMap[statusColor] : '', {
            'h-6': isCompact,
            'border-none': variant === 'inline',
          })}
        />
      </FormControl>
      {!isCompact && <FormMessage />}
    </FormItem>
  )
}
